import React from "react";
import { useOutletContext, useParams } from "react-router-dom"; // allows passing data in from parent, essential for this component

import PropTypes from "prop-types";

//import "./overview.css";
import "./projects.css";

const Overview = (props) => {
  const context = useOutletContext();
  var params = useParams();
  var entry = context['fulldata'][context['title']] // context is a dictionary with 2 objects. The first object is the whole data set of all the archive entries. the second object is the title of the currently selected one. This line loads the entry from the whole data set that has the title selected.
  return (
    <div className="overview-container">
      <h1 className="overview-title Body-L">{entry.title}</h1>
      <span className="overview-text Body-M">{entry.overview}</span>
			<br /><br />
      <div className="overview-gallery">
        <img
          classname="overview-galley"
          _jsm
          src={entry.image1}
          className="overview-image1"
        />
        <img src={entry.image2} className="overview-image2" />
        <img src={entry.image3} className="overview-image3" />
        <img src={entry.image4} className="overview-image4" />
      </div>
    </div>
  );
};

Overview.defaultProps = {
  rootClassName: "",
  title: "Title",
  text: "Synopsis",
  imageId: "",
  imageId1: "",
};

Overview.propTypes = {
  rootClassName: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  imageId: PropTypes.string,
  imageId1: PropTypes.string,
};

export default Overview;
